import Marquee from "react-fast-marquee";

const phrases = [
  "REPLANT",
  "REBUILD",
  "RESTORE",
  "$AFTBRN",
  "REFOREST",
  "RECOVER",
  "REGROW",
  "$AFTBRN",
];

export default function Ticker() {
  return (
    <div className="border-y border-white/10 bg-forest/20 py-5" data-testid="ticker">
      <Marquee speed={50} gradient={false} autoFill>
        {phrases.map((p, i) => (
          <span
            key={`${p}-${i}`}
            className="mx-8 font-display font-bold text-2xl sm:text-3xl tracking-tight text-foreground/80 flex items-center gap-8"
          >
            {p}
            <span className="text-ember">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
